import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { API } from "../global";
import { Movie } from "./Movie";

// import Counter from "./Counter.js"; // 2. default export & import
export function MovieList() {
  const history = useHistory();

  const [movies, setMovies] = useState([]);

  const getMovies = () => {
    fetch(`${API}/movies`, {
      method: "GET",
    }) // returns a promise object
      .then((data) => data.json())
      .then((mvs) => setMovies(mvs));
  };

  useEffect(getMovies, []);

  const removeMovie = (id) => {
    //After delete -> Refresh the movie list
    fetch(`${API}/movies/${id}`, {
      method: "Delete",
    }).then(() => getMovies());
  };

  return (
    <section className="movie-list">
      {movies.map(({ name, poster, summary, rating, id, _id }) => (
        <Movie
          name={name}
          poster={poster}
          summary={summary}
          rating={rating}
          id={_id}
          deleteButton={
            <IconButton
              onClick={() => removeMovie(_id)}
              color="error"
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton>
          }
          editButton={
            <IconButton
              style={{ marginLeft: "auto" }}
              onClick={() => history.push("/movies/edit/" + _id)}
              color="secondary"
              aria-label="delete"
            >
              <EditIcon />
            </IconButton>
          }
        />
      ))}
    </section>
  );
}

// /movies/edit/:id

// C - Create - Done AddMovie
// R - Read - Done MovieList, MovieDetails
// U - Update - EditMovie - Combination of MovieDetails & AddMovie
// D - Delete - Done

// // let x  = 5;

// // // 1000...lines of code

// // console.log(x);

// const x = 10;

// // 1000...lines of code

// console.log(x); // 10

// // const y = [1,2,3];

// // // 1000...lines of code  push, splice

// // console.log(y);

// const y = [1,2,3];

// // 1000...lines of code creates a copy

// console.log(y); // [1,2,3]
